'use client'

// React client — useSession() must be a React hook (vanilla client exports a nanostores Atom).
import { createAuthClient } from 'better-auth/react'
import {
  oneTapClient,
  inferAdditionalFields,
  emailOTPClient,
} from 'better-auth/client/plugins'

import {
  authSessionAdditionalFields,
  authUserAdditionalFields,
} from '@/core/auth/shared/additional-fields'

export const authClient = createAuthClient({
  baseURL: process.env.NEXT_PUBLIC_APP_URL,
  sessionOptions: {
    refetchOnWindowFocus: false,
  },
  plugins: [
    oneTapClient({
      clientId: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID!,
      // Optional client configuration:
      autoSelect: false,
      cancelOnTapOutside: true,
      context: 'signin',
    }),
    emailOTPClient(),
    inferAdditionalFields({
      user: authUserAdditionalFields,
      session: authSessionAdditionalFields,
    }),
  ],
})

// Keep the session atom mounted for the page lifetime. Otherwise React
// Suspense/hydration drops all subscribers, nanostores remounts the atom,
// and useSession aborts/refetches get-session in a tight loop
// (https://github.com/better-auth/better-auth/issues/10740).
if (typeof window !== 'undefined') {
  authClient.$store.atoms.session.listen(() => {})
}

// Export runtime functions for client components
export const {
  signIn,
  signOut,
  signUp,
  useSession,
  requestPasswordReset,
  resetPassword,
  changePassword,
  sendVerificationEmail,
  linkSocial,
  oneTap,
  emailOtp,
} = authClient

// Export types for TypeScript inference (optional - can also import from auth.ts)
export type Session = typeof authClient.$Infer.Session
